import { render, staticRenderFns } from "./OrderReplacementItemNew.vue?vue&type=template&id=ae32f882"
import script from "./OrderReplacementItemNew.vue?vue&type=script&lang=ts"
export * from "./OrderReplacementItemNew.vue?vue&type=script&lang=ts"
import style0 from "./OrderReplacementItemNew.vue?vue&type=style&index=0&id=ae32f882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports